import React, { Component } from 'react'

export default class RecruitSection extends Component {
    render() {
        return (
            <React.Fragment>
                <div className="container-box" id="home-recruit-container">
                    <div className="row row-title">
                        <div className='col col-hr'><hr></hr></div>
                        <div className='col-12 col-md-6 col-lg-3'>
                            <h1 className="text-blue">採用情報</h1>
                            <h5>RECRUITMENT</h5>
                        </div>
                        <div className='col col-hr'><hr></hr></div>
                    </div>
                    <div className="row justify-content-around mb-5">
                        <div className="col-12 recruit-title">
                            <h1>必要なのは、失敗を恐れず、決して諦めず、挑戦し続ける姿勢です。</h1>
                            <p>
                                弊社の求める人材について、能力的な制限はありません。 自分が興味のあることについて何でも挑戦する、
                                チャレンジ精神が旺盛な人を期待しています。 大切なのは、意欲を持って仕事に取り組み、学び続けること。 
                                仲間とともに成長し、リーダーシップを培っていきましょう。
                            </p>
                        </div>
                        <div className="col-8 col-sm-5 mb-3 recruit-card">
                            <div className="recruit-card-outer">
                                <a href="/people">
                                <div className="recruit-card-inner">
                                    <div className="recruit-card-img"><i className="fa fa-search fa-5x"></i></div>
                                    <div className="recruit-card-content">
                                        <h2>求める人材</h2>
                                        <p>「人が仕事をつくる」私たちが求めるのはチャレンジ精神を持ったあなたです。</p>
                                    </div>
                                </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-8 col-sm-5 mb-3 recruit-card">
                            <div className="recruit-card-outer">
                                <a href="/people#voices">
                                <div className="recruit-card-inner">
                                    <div className="recruit-card-img"><i className="fa fa-weixin fa-5x"></i></div>
                                    <div className="recruit-card-content">
                                        <h2>先輩社員の声</h2>
                                        <p>弊社で活躍する先輩社員の声を紹介します。</p>
                                    </div>
                                </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-8 col-sm-5 mb-3 recruit-card">
                            <div className="recruit-card-outer">
                                <a href="/recruit">
                                <div className="recruit-card-inner">
                                    <div className="recruit-card-img"><i className="fa fa-clipboard fa-5x"></i></div>
                                    <div className="recruit-card-content">
                                        <h2>募集内容</h2>
                                        <p>詳細はこちら。</p>
                                    </div>
                                </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-8 col-sm-5 mb-3 recruit-card">
                            <div className="recruit-card-outer">
                                <a href="/recruit-form">
                                <div className="recruit-card-inner">
                                    <div className="recruit-card-img"><i className="fa fa-envelope fa-5x"></i></div>
                                    <div className="recruit-card-content">
                                        <h2>応募フォーム</h2>
                                        <p>ご応募はこちら。</p>
                                    </div>
                                </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
